/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { Tooltip } from 'components/common';
import { withTheme } from 'styled-components';
import { addAriaLive } from 'utils/dom';
import { PopoverContent } from './DropdownInputPopover.styled';

type DropdownInputPopoverProps = {
  data: any[];
  theme: { [key: string]: any };
  popoverPosition: any;
  isPopoverOpen: boolean;
  isMatching: boolean;
  getMenuProps(): void;
  getItemProps(options: any): void;
  selectedAnswer: any;
  highlightedIndex: number | null;
  setHighlightedIndex(index: any): void;
  children: any;
  questionType?: string;
};

export class DropdownInputPopover extends React.Component<DropdownInputPopoverProps, {}> {
  classes: any;
  screenReader: any;
  options: any;

  constructor(props: DropdownInputPopoverProps) {
    super(props);
    this.classes = {
      baseSelected: 'selected',
      matchingSelected: 'selected current',
      matchingSelectedCurrent: 'current-selected'
    };
    this.options = '';
  }

  addClasses(item: any) {
    const { isMatching, selectedAnswer } = this.props;
    const { baseSelected, matchingSelected, matchingSelectedCurrent } = this.classes;

    const { value, selected, current } = item;

    if (!isMatching) {
      if (selectedAnswer === value) {
        return baseSelected;
      }
      return '';
    }
    if (selected && selected.length) {
      if (current) {
        return matchingSelectedCurrent;
      }
      return matchingSelected;
    }
    return '';
  }

  updateAriaLiveElement = () => {
    const dropDownInputPopoverUpdate = this.getDropDownInputPopoverUpdate();
    if (dropDownInputPopoverUpdate) {
      const elementP = document.createElement('p');
      elementP.innerText = this.options;
      dropDownInputPopoverUpdate.innerHTML = '';
      dropDownInputPopoverUpdate.appendChild(elementP);
    }
  };

  ariaGetAnswerOptions = () => {
    this.options = ' ';

    for (const index in this.props.data) {
      this.options += `${this.props.data[index].value} `;
    }

    setTimeout(this.updateAriaLiveElement, 500);
  };

  componentDidMount(): void {
    addAriaLive({
      id: 'dropDownInputPopover',
      attributes: [{ key: 'aria-live', value: 'polite' }]
    });
  }

  componentDidUpdate(prevProps: Readonly<DropdownInputPopoverProps>): void {
    if (!prevProps.isPopoverOpen && this.props.isPopoverOpen) {
      this.ariaGetAnswerOptions();
    }
  }

  getDropDownInputPopoverUpdate = () => document.getElementById('dropDownInputPopover');

  render() {
    const {
      isPopoverOpen,
      isMatching,
      popoverPosition,
      data,
      highlightedIndex,
      setHighlightedIndex,
      getItemProps,
      children,
      questionType
    } = this.props;
    const templateTheme = this.props.theme;
    return (
      <Tooltip
        trigger={'manual'}
        open={isPopoverOpen}
        distance={isMatching ? 0 : 16}
        classNames="dropdown"
        tooltipTheme={'light'}
        position={popoverPosition}
        html={
          <PopoverContent tabIndex={0} isMatching={isMatching} theme={templateTheme}>
            <div
              data-test="dropdown-content"
              className="downshift-dropdown"
              role="list"
              aria-live="assertive"
            >
              {data.map((item: any, index: any) => (
                <div
                  key={index}
                  tabIndex={0}
                  role="listitem"
                  className={`dropdown-item ${this.addClasses(item)}`}
                  data-test="dropdown-item"
                  style={{
                    color: highlightedIndex === index ? templateTheme.colors.mainColor : null
                  }}
                  onMouseLeave={() => setHighlightedIndex(null)}
                  {...getItemProps({
                    key: index,
                    index,
                    item
                  })}
                >
                  <div aria-label={highlightedIndex === index ? item.value : null}>
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </PopoverContent>
        }
        questionType={questionType}
      >
        {children}
      </Tooltip>
    );
  }
}

export default withTheme(DropdownInputPopover);
